import { LiteGroup } from "@converge-collective/common/models/Group";
import { Autocomplete, TextField, Typography } from "@mui/material";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import { isArray, isEmpty } from "lodash";
import React, { useState } from "react";
import { useNetworkMembership } from "~/hooks/useNetworkMembership";

type Props = {
  onSetGroups: (groups: LiteGroup[]) => void;
  multiple?: boolean;
  required?: boolean;
  helperText?: string;
  initSelected?: LiteGroup[];
};

export default function AutocompleteGroup({
  onSetGroups,
  multiple = false,
  required = true,
  helperText = "",
  initSelected,
}: Props): React.ReactElement {
  const networkMembership = useNetworkMembership();
  const [selectedGroups, setSelectedGroups] = useState<LiteGroup[]>(
    initSelected || []
  );
  const [isValidGroup, setIsValidGroup] = useState(true);

  const validateGroup = (value = selectedGroups) => {
    setIsValidGroup(!isEmpty(value));
  };

  const { groupMemberships } = networkMembership || {};
  const userGroups = groupMemberships ? Object.values(groupMemberships) : [];
  const loading = !networkMembership;

  return (
    <Autocomplete
      openOnFocus
      autoComplete
      autoSelect
      multiple={multiple}
      autoHighlight
      loading={loading}
      options={userGroups}
      value={selectedGroups}
      getOptionLabel={(group: LiteGroup) => group.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={(_, newValue) => {
        console.log("set group", { newValue });
        if (newValue) {
          const groups = isArray(newValue) ? newValue : [newValue];
          validateGroup(groups);
          setSelectedGroups(groups);
          onSetGroups(groups);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          label={multiple ? "Groups" : "Group"}
          helperText={helperText}
          fullWidth
          error={required && !isValidGroup}
        />
      )}
      renderOption={(props, option: LiteGroup, { inputValue }) => {
        const matches = match(option.name, inputValue);
        const parts = parse(option.name, matches);

        return (
          <li
            {...props}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              {parts.map((part, index: number) => (
                <span
                  key={index}
                  style={{ fontWeight: part.highlight ? 700 : 400 }}
                >
                  {part.text}
                </span>
              ))}
            </div>
            <div style={{ color: "gray" }}>
              <Typography variant="overline"></Typography>
            </div>
          </li>
        );
      }}
    />
  );
}
